module.exports = __webpack_public_path__ + "img/footer_01_fanfan.6aa388af.png";